import { render } from "./ItemsSectionContainer.vue?vue&type=template&id=9a9b98e2"
import script from "./ItemsSectionContainer.vue?vue&type=script&lang=js"
export * from "./ItemsSectionContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__